import React from 'react'
import { Row, Col } from 'reactstrap'
import moment from 'moment'
import { extractExpirationInfo } from 'lib/util'
import FieldsetItem from 'components/FieldsetItem'
import FieldsetItemLarge from 'components/FieldsetItemLarge'

interface NetSuiteAssetDetailsProps {
  selectedNetSuiteAsset: any
}

const NetSuiteAssetDetails: React.FC<NetSuiteAssetDetailsProps> = ({
  selectedNetSuiteAsset,
}) => {
  if (!selectedNetSuiteAsset) return null

  const { product } = selectedNetSuiteAsset
  const expiration = extractExpirationInfo(selectedNetSuiteAsset, 'YYYY-MM-DD')

  return (
    <fieldset>
      <legend>Details</legend>
      <Row>
        <Col sm={8}>
          <FieldsetItemLarge
            data={selectedNetSuiteAsset.nsName}
            title="Assigned To"
          />
          <FieldsetItemLarge data={product.description || ''} title="Product" />
        </Col>
        <Col sm={4}>
          <FieldsetItem
            color="none"
            data={expiration.startDate.formatted}
            title="Start Date"
          />
          <FieldsetItem
            color={expiration.isExpired ? 'danger' : 'none'}
            title="Expiration"
          >
            {expiration.icon} {expiration.expirationDate.formatted}
          </FieldsetItem>
          {selectedNetSuiteAsset.cancelledDate && (
            <FieldsetItem
              color="warning"
              data={expiration.cancelledDate.formatted}
              title="Cancellation"
            />
          )}
          <FieldsetItem
            color="none"
            data={moment(selectedNetSuiteAsset.modifiedDate).format(
              'YYYY-MM-DD',
            )}
            title="Modified Date"
          />
        </Col>
      </Row>
    </fieldset>
  )
}

export default NetSuiteAssetDetails
